import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import IconButton from '../../../Button/IconButton';
import BurgerIcon from '@wix/da-ds/pkg/Icons/Burger';
import NetworkBar from '../../../NetworkBar';
import s from './BurgerMenu.scss';
var BurgerMenu = function (_a) {
    var className = _a.className, iconClassName = _a.iconClassName, _b = _a.showNetworkBar, showNetworkBar = _b === void 0 ? true : _b, isBurgerMenuOpen = _a.isBurgerMenuOpen, toggleBurgerMenu = _a.toggleBurgerMenu;
    var t = useTranslation().t;
    // TODO: this thing is doing some rather hacky business with hovers and
    // modals to make the opening/closing animations work. Should rewrite to
    // something cleaner when we find the time
    var _c = useState(isBurgerMenuOpen), showModal = _c[0], setShowModal = _c[1];
    var _d = useState(false), isClosing = _d[0], setIsClosing = _d[1];
    // because of the hover-hack, we cannot rely on react-modal to handle the body locking for us
    useEffect(function () {
        if (isBurgerMenuOpen) {
            document.body.classList.add(s['body-lock']);
            return function () { return document.body.classList.remove(s['body-lock']); };
        }
    }, [isBurgerMenuOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { "aria-expanded": isBurgerMenuOpen, "aria-label": t('siteHeader.burger.a11y'), "aria-controls": "burger-menu-networkbar", onClick: function () {
                /* the Modal will render before this, isBurgerMenuOpen only controls opacity and starts the animation */
                toggleBurgerMenu(!isBurgerMenuOpen);
            }, 
            /* add the Modal to the DOM so we can show animation */
            onMouseEnter: function () { return setShowModal(true); }, 
            /* if the menu is not open remove the Modal */
            onMouseLeave: function () { return !isBurgerMenuOpen && setShowModal(false); }, className: className, biData: {
                evid: BiEventType.NETWORK_BAR_MENU_ICON,
                is_expanding: isBurgerMenuOpen || isClosing ? 0 : 1,
            } },
            React.createElement(BurgerIcon, { disableDefaultColors: true, className: iconClassName })),
        showNetworkBar && (React.createElement(Modal, { isOpen: showModal, shouldCloseOnOverlayClick: true, shouldCloseOnEsc: true, className: classnames(s['modal-root'], isBurgerMenuOpen && s['modal-root-open']), overlayClassName: classnames(s['overlay'], isBurgerMenuOpen && s['overlay-open']), bodyOpenClassName: null, onRequestClose: function () {
                setIsClosing(true);
                /* wait for animation to finish to remove the Modal */
                setTimeout(function () {
                    setShowModal(false);
                    setIsClosing(false);
                }, 300);
                toggleBurgerMenu(false);
            } },
            React.createElement(NetworkBar, { id: "burger-menu-networkbar", isVisible: isBurgerMenuOpen })))));
};
BurgerMenu.displayName = 'BurgerMenu';
export default BurgerMenu;
//# sourceMappingURL=BurgerMenu.js.map